module.exports = __webpack_public_path__ + "img/login_left.14f89e03.png";